import React, { useState } from 'react'
import { WHATSAPP_NUMBER } from '@constants/contact'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { FaClinicMedical } from 'react-icons/fa'
import { MdKeyboardArrowRight } from 'react-icons/md'
import Medico from '@resources/imgs/medico--1.svg'
import Esperma1 from '@resources/imgs/esperma--1.svg'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { FaCircleQuestion } from 'react-icons/fa6'
import { isFullName } from '@helpers/Validation'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

const SweetAlert = withReactContent(Swal)

const animatedComponents = makeAnimated()

type OptionType = { value: string; label: string }

interface ClinicDataStepProps {
  states: OptionType[]
  clinics: OptionType[]
  treatmentTypes: OptionType[]
  formData: any
  selectedClinic: OptionType | null
  selectedTreatment: string
  handleSelectChange: (key: string, value: any) => void
  handleInputChange: (key: string, value: string) => void
  setSelectedClinic: (clinic: OptionType | null) => void
  City: React.ComponentType
  onNext: () => void
}

const ClinicDataStep: React.FC<ClinicDataStepProps> = ({
  states,
  clinics,
  treatmentTypes,
  formData,
  selectedClinic,
  selectedTreatment,
  handleSelectChange,
  handleInputChange,
  setSelectedClinic,
  City,
  onNext,
}) => {
  const [showVideoModal, setShowVideoModal] = useState(false)
  const [showVideo2Modal, setShowVideo2Modal] = useState(false)

  const handleHelpClick = () => setShowVideoModal(true)
  const handleCloseModal = () => setShowVideoModal(false)

  const handleHelp2Click = () => setShowVideo2Modal(true)
  const handleClose2Modal = () => setShowVideo2Modal(false)

  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleNext = async () => {
    setIsSubmitting(true)
    try {
      await onNext()
    } finally {
      setIsSubmitting(false)
    }
  }
  const handleDoctorNameBlur = () => {
    if (formData?.doctor_name && !isFullName(formData.doctor_name)) {
      SweetAlert.fire({
        title: 'Erro!',
        text: 'Nome completo é obrigatório (nome e sobrenome).',
        icon: 'error',
        confirmButtonText: 'Ok',
      })
    }
  }

  // Validate if all required fields are filled
  const isFormValid = () => {
    const requiredFields = ['clinic_state', 'clinic_city', 'doctor_name', 'doctor_crm', 'treatment_type_id', 'treatment_date']
    const hasClinic = selectedClinic !== null
    const hasAllFields = requiredFields.every(field => formData[field] && String(formData[field]).trim() !== '')
    const hasValidDoctorName = isFullName(formData?.doctor_name)
    return hasClinic && hasAllFields && hasValidDoctorName
  }

  return (
    <div className="request-page">
      <div className="title mb-3">
        <h5>Dados para Solicitação de Pré-Reserva</h5>
        <p>Selecione a sua clínica ou laboratório onde será realizado o tratamento, preencha os dados do médico responsável e tipo de tratamento para prosseguir com a pré-reserva.</p>
      </div>
      <div className="select-sample">
        <div className="row">
          <div className="col-12 col-sm-6 col-lg-4 px-2">
            <div className="sample-box mt-2 pb-2">
              <div className="text d-flex">
                <FaClinicMedical />
                <p>
                  Dados da Clínica/Laboratório
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <FaCircleQuestion style={{ color: '#FA5A84', marginLeft: '5px', cursor: 'pointer', fontSize: '14px' }} onClick={handleHelpClick} />
                  </span>
                </p>
              </div>
              <div className="form-line">
                <div className="row">
                  <div className="col-12 col-md-4 pr-md-1">
                    <div className="form-group">
                      <div className="text-box mb-2">
                        <p className="mb-0">Estado <span>*</span></p>
                      </div>
                      <Select
                        className="react-select"
                        placeholder={<div>UF</div>}
                        components={animatedComponents}
                        options={states}
                        value={states.find(s => s.value === formData?.clinic_state)}
                        defaultValue={states.find(s => s.value === formData?.clinic_state)}
                        onChange={value => value ? handleSelectChange('clinic_state', value) : null}
                        isClearable={true}
                        isSearchable={true}
                        isDisabled={false}
                        isLoading={false}
                        isRtl={false}
                        closeMenuOnSelect={true}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 1000 })
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-8 pl-md-1">
                    <div className="form-group">
                      <div className="text-box mb-2">
                        <p className="mb-0">Cidade <span>*</span></p>
                      </div>
                      <City />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-line">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group mb-0">
                      <div className="text-box mb-2">
                        <p className="mb-0">Clínica/Laboratório para envio da amostra <span>*</span></p>
                      </div>
                      <Select
                        className="react-select"
                        placeholder={formData?.clinic_city && clinics.length === 0 ? <div>Nenhuma clínica encontrada</div> : <div>Selecione a Clínica</div>}
                        components={animatedComponents}
                        options={clinics}
                        value={selectedClinic}
                        onChange={(opt) => setSelectedClinic(opt as OptionType | null)}
                        isClearable={true}
                        isSearchable={true}
                        isDisabled={!formData?.clinic_city}
                        isLoading={false}
                        isRtl={false}
                        closeMenuOnSelect={true}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 1000 })
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-0 mt-3">
                <small>Não encontrou sua clínica? <Link to={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Não encontrei a minha clínica.')}`} target="_blank"><span>Clique aqui</span></Link></small>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4 px-2">
            <div className="sample-box mt-2">
              <div className="text d-flex">
                <img src={Medico} alt="" />
                <p>Dados do Médico</p>
              </div>
              <div className="form-line">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <div className="text-box mb-2">
                        <p className="mb-0 mr-2">Nome Completo do Médico Responsável <span>*</span></p>
                      </div>
                      <input
                        className={`form-control ${formData?.doctor_name && !isFullName(formData.doctor_name) ? 'is-invalid' : ''}`}
                        type="text"
                        value={formData?.doctor_name || ''}
                        onChange={(e) => handleInputChange('doctor_name', e.target.value)}
                        onBlur={handleDoctorNameBlur}
                        disabled={!selectedClinic}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group mb-4">
                      <div className="text-box mb-2">
                        <p className="mb-0">CRM do Médico <span>*</span></p>
                      </div>
                      <input
                        className="form-control"
                        type="text"
                        value={formData?.doctor_crm || ''}
                        onChange={(e) => handleInputChange('doctor_crm', e.target.value)}
                        disabled={!selectedClinic}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-lg-4 px-2">
            <div className="sample-box mt-2">
              <div className="text d-flex">
                <img src={Esperma1} alt="" />
                <p>
                  Dados do Tratamento
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <FaCircleQuestion style={{ color: '#FA5A84', marginLeft: '5px', cursor: 'pointer', fontSize: '14px' }} onClick={handleHelp2Click} />
                  </span>
                </p>
              </div>
              <div className="form-line">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <div className="text-box d-flex mb-2">
                        <p className="mb-0 mr-2">Tipo de tratamento <span>*</span></p>
                      </div>
                      <Select
                        className="react-select"
                        placeholder={<div>Selecione</div>}
                        components={animatedComponents}
                        options={treatmentTypes}
                        value={selectedTreatment ? treatmentTypes.find((s: any) => s.label === selectedTreatment) : null}
                        onChange={value => value ? handleSelectChange('treatment_type_id', value) : null}
                        isClearable={true}
                        isSearchable={true}
                        isDisabled={!selectedClinic}
                        isLoading={false}
                        isRtl={false}
                        closeMenuOnSelect={true}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 1000 })
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-line">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group mb-0">
                      <div className="text-box d-flex mb-2">
                        <p className="mb-0">Data prevista do tratamento <span>*</span></p>
                      </div>
                      <input
                        className="form-control"
                        type="date"
                        value={formData?.treatment_date ? moment(formData?.treatment_date).format('YYYY-MM-DD') : ''}
                        onChange={(e) => handleInputChange('treatment_date', e.target.value)}
                        disabled={!selectedClinic}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="request-footer">
        <div className="row">
          <div className="col-12 d-flex justify-content-between">
            <Link className="return-btn cancel-btn btn btn-primary" to="/carrinho">
              Cancelar
            </Link>
            <button
              className="next-btn btn btn-primary"
              onClick={handleNext}
              disabled={!isFormValid() || isSubmitting}
            >
              {isSubmitting ? 'Enviando...' : 'Próximo passo'}
              <MdKeyboardArrowRight />
            </button>
          </div>
        </div>
      </div>
      {showVideoModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={handleCloseModal}>
          <div style={{ position: 'relative', width: 'min(1280px, 90vw)' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }} src="https://www.youtube.com/embed/tkR49si6Blw" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>
            <button style={{ position: 'absolute', top: '-10px', right: '-10px', background: 'red', color: 'white', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: 'pointer' }} onClick={handleCloseModal}>×</button>
          </div>
        </div>
      )}
      {showVideo2Modal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={handleClose2Modal}>
          <div style={{ position: 'relative', width: 'min(1280px, 90vw)' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }} src="https://www.youtube.com/embed/LemLR2jeGAE" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>
            <button style={{ position: 'absolute', top: '-10px', right: '-10px', background: 'red', color: 'white', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: 'pointer' }} onClick={handleClose2Modal}>×</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ClinicDataStep